import { render, staticRenderFns } from "./OpenBillingInvoicePreview.vue?vue&type=template&id=084b9822&scoped=true&"
import script from "./OpenBillingInvoicePreview.vue?vue&type=script&lang=js&"
export * from "./OpenBillingInvoicePreview.vue?vue&type=script&lang=js&"
import style0 from "./OpenBillingInvoicePreview.vue?vue&type=style&index=0&id=084b9822&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "084b9822",
  null
  
)

export default component.exports